import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterGroup } from '../../../../models/filter-group.model';
import { FilterItem } from '../../../../models/filter-item.model';
import {applyFilterAction, isEmptyArray} from '../../../../shared/utils';

@Component({
    selector: 'selected-filters',
    templateUrl: './filter-selected-group.component.html',
    styleUrls: ['./filter-selected-group.component.scss']
})
export class FilterSelectedGroupComponent {

    @Input() showClearAllButton = false;

    _selectedFilters: FilterItem[] = [];
    _filterGroups: FilterGroup[];
    @Input() set filters(val: FilterGroup[]) {
        this._filterGroups = val;
        this._selectedFilters = this.getSelectedFilters(this._filterGroups);
    }

    @Output() removeFilter = new EventEmitter<FilterGroup[]>();

    private getSelectedFilters(filterGroups: FilterGroup[]): FilterItem[] {
        const result: FilterItem[] = [];

        if (filterGroups) {
            filterGroups.forEach( filterGroup => {
                if (!isEmptyArray(filterGroup.selectedFilters)) {
                    filterGroup.selectedFilters.forEach( filterItem => {
                        // skip already selected filter
                        if (!result.find( i => i.label === filterItem.label)) {
                            result.push(filterItem);
                        }
                    });
                }
            });
        }

        return result;
    }

    remove(removedItem: FilterItem) {
        this._filterGroups.forEach( filterGroup => {
            applyFilterAction(filterGroup, (item: FilterItem) => {
                if (item.label === removedItem.label) {
                    item.selected = false;
                }
            })
        });
        this._selectedFilters = this.getSelectedFilters(this._filterGroups);

        this.removeFilter.emit(this._filterGroups);
    }

    clearAll() {
        this._filterGroups.forEach( f => {
            f.clearSelection();
            f.expanded = false;
        });

        this.removeFilter.emit(this._filterGroups);
        return false;
    }
}
